import {Typography} from '@mui/material';
import * as React from 'react';
import {Modal} from 'react-bootstrap';
import {FormattedMessage, defineMessages, useIntl} from 'react-intl';

import styles from './ChangedByOtherDialog.less';
import {DlMuiButton} from './DlMuiButton';
import {TranslateUtils} from '../common';
import {statusSlice} from '../containers/status';
import {useAppDispatch} from '../store_hooks';

const I18N = defineMessages({
  TITLE: {
    id: 'common.confirmDialog.title',
    defaultMessage: 'Confirm action',
    description: 'title text for confirm dialog',
  },
  CHANGED_BY_OTHER_MESSAGE: {
    id: 'common.changedByOtherDialog.message',
    defaultMessage: 'Data was changed by another user. Your changes will be lost.',
    description: 'Confirm changed by another user message',
  },
  YOUR_CHANGES: {
    id: 'common.changedByOtherDialog.yourChanges',
    defaultMessage: 'Your changes',
    description: 'Your changes title',
  },
  ACCEPT: {
    id: 'common.confirmDialog.accept',
    defaultMessage: 'OK',
    description: 'confirm text for confirm button in confirm dialog',
  },
});

interface OwnProps {
  isOpened: boolean;
  changes: Record<string, string>;
  handleConfirm: () => void;
}

type Props = OwnProps;

export const ChangedByOtherDialog: React.FC<Props> = (props) => {
  const {isOpened, changes, handleConfirm} = props;
  const intl = useIntl();
  const t = (key) => key && TranslateUtils.translate(key, intl);

  return (
    <Modal show={isOpened} className={styles.changedByOtherModal}>
      <Modal.Header className={styles.modalHeader}>
        <Modal.Title>
          <Typography variant='cardHeader'>
            <FormattedMessage {...I18N.TITLE} />
          </Typography>
        </Modal.Title>
        <FormattedMessage {...I18N.CHANGED_BY_OTHER_MESSAGE} />
      </Modal.Header>
      <Modal.Body>
        <Typography variant='labelBold'>{t(I18N.YOUR_CHANGES.id)}</Typography>
        {Object.entries(changes).map(([k, v]) => (
          <div key={k} className={styles.changeRow}>
            <Typography variant='label' style={{minWidth: 105, maxWidth: 105, overflowWrap: 'break-word'}}>
              {k}
            </Typography>
            <Typography variant='value'>{v}</Typography>
          </div>
        ))}
        <div className={styles.modalFooter}>
          <DlMuiButton type='chip-filled' onClick={handleConfirm} title={TranslateUtils.translate(I18N.ACCEPT.id, intl)}>
            <FormattedMessage {...I18N.ACCEPT} />
          </DlMuiButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

ChangedByOtherDialog.displayName = 'ChangedByOtherDialog';

type UseChangedByOtherDialogProps = Omit<Props, 'isOpened' | 'changes'>;
export function useChangedByOtherDialog(props: UseChangedByOtherDialogProps) {
  const {handleConfirm} = props;
  const [isOpened, setIsOpened] = React.useState(false);
  const [changes, setChanges] = React.useState({});

  const dispatch = useAppDispatch();
  const clearErrorStatus = React.useCallback(() => {
    dispatch(statusSlice.actions.clearErrors());
  }, [dispatch]);

  return {
    changedByOtherDialog: (
      <ChangedByOtherDialog
        isOpened={isOpened}
        changes={changes}
        handleConfirm={() => {
          setIsOpened(false);
          handleConfirm();
        }}
      />
    ),
    showChangedByOtherDialog: (newChanges: Record<string, string>) => {
      clearErrorStatus();
      setChanges(newChanges);
      setIsOpened(true);
    },
  };
}
export const CHANGED_BY_OTHER_USER_STATUS = 412;
